// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"43b07f44","455":"1e67cce0","457":"0ca12018","551":"2e295c25","977":"94de488a"}[chunkId] + ".chunk.js";
};